var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 14h8",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "color-sensitive"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.136 11.527a.77.77 0 0 0 1.42-.592l-3.492-8.381A.9.9 0 0 0 9.234 2h-.467a.9.9 0 0 0-.831.554l-3.492 8.38a.77.77 0 0 0 1.42.592l.994-2.383h4.284l.994 2.384zM7.45 7.714 9 4l1.55 3.714h-3.1z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextColor);
export default __webpack_public_path__ + "static/media/textColor.51c9439ce1f71089c84af1cd23c3694d.svg";
export { ForwardRef as ReactComponent };